import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Growl } from 'primereact/growl';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import servicioHttp from '../../servicio/ServicioHttp';
import servicioFormatos from '../../servicio/ServicioFormatos';
import { obtenerInformacionNavegador } from '../../servicio/ServicioInformacionNevegador';
import servicioObjetos from '../../servicio/ServicioObjetos';
import { CALENDARIO_ES_MX } from '../../servicio/ServicioConstantes';

import { DetalleMovimientosCliente } from './DetalleMovimientosCliente';

const ROL_CLIENTE = 1;
const PAGINACION_INICIAL = {
    registrosPorPagina: 1000,
    registrosTotales: 0,
    join: {
        'tcPerfils': 'alias_tcPerfils',
        'tcPlan': 'alias_plan'
    },
    restriccionesDinamicas: [
        {
            tipoRestriccion: 'eq',
            nombrePropiedad: 'alias_tcPerfils.rol',
            valorPropiedad: ROL_CLIENTE
        }
    ]
}
export class AdministracionUsuarios extends Component {
    constructor() {
        super();
        this.state = {
            paginacion: { ...PAGINACION_INICIAL },
            usuario: {},
            errores: {},
            mostrarRegistro: false,
            mostrarModalPlan: false,
            mostrarModalDetalle: false,
            mostrarEditarCliente: false,
            aplicaHistorico: false,
            fechaCorteFormateada:""
        };
        this.paginar();
    }

    asignarDatos = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }

    onIndexTemplate = (data, props) => {
        let idsenube = 0;
        return (props.rowIndex + 1) + idsenube;
    }

    paginar = () => {
        let { paginacion } = this.state;
        if (servicioObjetos.esObjetoVacio(paginacion.join))
            paginacion = { ...PAGINACION_INICIAL };
        servicioHttp.consumirPostHttp('admin/usuario/consultar.json', paginacion).then(response => {
            this.setState({ paginacion: response.data.objeto });
        }).catch(error => {

        });
    }

    columnaEstado = (objeto) => {
        if (objeto.estado === 1)
            return <p style={{ backgroundColor: '#ff9f00', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>;
        if (objeto.estado === 0)
            return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Inactivo</p>;
    }

    colunaFechaRegistro = (rowData, column) => {
        return servicioFormatos.formatearFechaString(rowData.fechaCreacion);
    }
    colunaFechaCorte = (rowData, column) => {
        return servicioFormatos.formatearFechaString(rowData.fechaCorte);
    }

    columnaOpciones = (rowData, column) => {
        return <div className="p-grid" style={{ width: "150px" }}>
            <div className="p-col-12 p-md-3">
                <Button
                    type="button"
                    icon="pi-md-edit"
                    onClick={(e) => this.mostrarModalEditarCliente(rowData)}
                    className="p-button-warning"
                    name="Editar"
                    tooltip="Editar">
                </Button>
            </div>
            <div className="p-col-12 p-md-3">
                <Button
                    type="button"
                    icon={rowData.estado === 1 ? "pi-md-lock" : "pi-md-lock-open"}
                    onClick={(e) => this.suspender(rowData)}
                    className="p-button-warning"
                    name={rowData.estado === 1 ? "Suspender" : "Activar"}
                    tooltip={rowData.estado === 1 ? "Suspender" : "Activar"}>
                </Button>

            </div>
            <div className="p-col-12 p-md-3">
                <Button
                    type="button"
                    icon="pi-md-import-export"
                    onClick={(e) => this.mostrarModalCambioPlan(rowData)}
                    className="p-button-warning"
                    name="Cambiar Plan"
                    tooltip="Cambiar Plan">
                </Button>
            </div>

            <div className="p-col-12 p-md-3">
                <Button
                    type="button"
                    icon="pi-md-pageview"
                    onClick={(e) => this.mostrarModalDetalleUsuario(rowData)}
                    className="p-button-warning"
                    name="Ver movimientos"
                    tooltip="Ver movimientos">
                </Button>
            </div>
        </div>;
    }

    mostrarModalCambioPlan = (usuario) => {
        servicioHttp.consumirPostHttp('/plan/planes.json').then(response => {
            let planesResponse = this.convertirResponsePlanes(response);
            this.setState({
                planes: planesResponse
            });
            let elUsuario = servicioObjetos.esObjetoVacio(usuario) ? {} : usuario;            
            if (!servicioObjetos.esObjetoVacio(elUsuario.idPlan)) {
                let elPlan=servicioObjetos.obtenerObjetoDeArregloPorPropiedad(response.data.lista,"id",elUsuario.idPlan);
                let elOtroPlan=servicioObjetos.obtenerObjetoDeArregloPorPropiedad(planesResponse,"value",elPlan);
                elUsuario.plan = {
                    value: {elOtroPlan},
                    label: elOtroPlan.nombre
                };
                //Esto hay que revisarlo porque no se actualiza el DropDown
            }
            if (!servicioObjetos.esObjetoVacio(elUsuario.fechaCorte))
                elUsuario.fechaCorte = new Date(elUsuario.fechaCorte);
            this.setState({
                mostrarModalPlan: true,
                usuario: elUsuario,
                errores: {}
            });
        }).catch(error => {

        });
    }

    cerrarModalCambioPlan = () => {
        this.setState({
            mostrarModalPlan: false,
            usuario: {},
            errores: {}
        });
    }

    convertirResponsePlanes = (response) => {
        let planesResponse = response.data.lista;
        let list = [];
        for (let i = 0; i < planesResponse.length; i++) {
            let elemento = planesResponse[i];
            let nuevoElemento = {};
            nuevoElemento.value = elemento;
            nuevoElemento.label = elemento.nombre;
            list.push(nuevoElemento);
        }
        return list;
    }

    mostrarModalCrearCliente = () => {
        let paginacion = {
            registrosPorPagina: 50,
            numeroPagina: 0
        };
        servicioHttp.consumirPostHttp('/plan/planes.json', paginacion).then(response => {
            let planesResponse = this.convertirResponsePlanes(response);            
            this.setState({
                planes: planesResponse
            });                   
            this.setState({
                mostrarRegistro: true,
                usuario: {},
                fechaCorteFormateada:"",
                errores: {},
                aplicaHistorico: false
            });
        }).catch(error => {

        });
    }

    suspender = (usuario) => {
        let id = usuario.id;
        let estado = usuario.estado;
        if (estado === 1)
            estado = 0;
        else
            estado = 1;
        servicioHttp.consumirPostHttp('/admin/usuario/suspension.json', { id, estado }).then(response => {
            this.paginar();
        }).catch(error => {

        });
    }

    cerrarModalCrearCliente = () => {
        this.setState({
            mostrarRegistro: false,
            usuario: {}
        });
    }

    crearCuenta = () => {
        let { usuario } = this.state;
        const validacion = this.validarFormulario(usuario);
        this.setState({ errores: validacion });
        if (servicioObjetos.esObjetoVacio(validacion)) {
            let correoconfirmacion = usuario.correoconfirmacion;
            let confirmacontrasena = usuario.confirmacontrasena;
            let elPlan = usuario.plan;
            delete usuario.plan;
            delete usuario['plan'];
            delete usuario.correoconfirmacion;
            delete usuario['correoconfirmacion'];
            delete usuario.confirmacontrasena;
            delete usuario['confirmacontrasena'];
            usuario.tcPlan = {
                id: elPlan.id
            };
            let lafecha = usuario.fechaCorte.getTime();
            usuario.fechaCorte = lafecha;
            if (!servicioObjetos.esObjetoVacio(usuario.id))
                usuario.idPlan = elPlan.value;
            let elUrl = 'admin/usuario/registro.json';
            this.growl.clear();
            if (!servicioObjetos.esObjetoVacio(usuario.fechaInicioDescargaHistorico)) {
                usuario.aplicaHistorico = 1;
                usuario.fechaInicioDescargaHistorico = usuario.fechaInicioDescargaHistorico.getTime();
            }

            servicioHttp.consumirPostHttp(elUrl, usuario).then(response => {
                this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: '', detail: response.data.mensaje, life: 10000 });
                if (!response.data.error) {
                    this.cerrarModalCrearCliente();
                    this.paginar();
                    usuario = {};
                } else {
                    usuario.correoconfirmacion = correoconfirmacion;
                    usuario.confirmacontrasena = confirmacontrasena;
                    usuario.fechaCorte = new Date(usuario.fechaCorte);
                }
                this.setState({ usuario: usuario });
            }).catch(error => {
                this.growl.show({ severity: 'error', summary: 'Error', detail: "Existe un error de conexión al servidor, intente más tarde", life: 20000 });
            });
        }
    }

    validarFormulario = (usuario) => {
        let { aplicaHistorico } = this.state;
        const errores = {};
        var expreReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        var validacionCorreo = expreReg.exec(usuario.correo);

        if (!usuario.nombre)
            errores.nombre = "El nombre es requerido";
        if (!usuario.apellidoPaterno)
            errores.apellidoPaterno = "El apellido paterno es requerido";
        if (!usuario.usuario)
            errores.usuario = "El usuario es requerido";
        if (!usuario.correo)
            errores.correo = "El usuario es requerido";
        if (!validacionCorreo)
            errores.correo = "El correo no es valido";

        if (!usuario.correoconfirmacion)
            errores.correoconfirmacion = "Los correos no coinciden";
        if (usuario.correoconfirmacion !== usuario.correo)
            errores.correoconfirmacion = "El correo no coincide";

        if (!usuario.aliasCliente)
            errores.aliasCliente = "Debe de agregar un alias del cliente";

        if (servicioObjetos.esObjetoVacio(usuario.id)) {
            if (!usuario.contrasena)
                errores.contrasena = "La contraseña es requerida";
            if (!usuario.confirmacontrasena)
                errores.confirmacontrasena = "La confirmación de contraseña es requerida";
            if (usuario.contrasena !== usuario.confirmacontrasena)
                errores.confirmacontrasena = "Las contraseñas no coinciden";
            if (!usuario.plan)
                errores.plan = "Debe de elegir un plan para el cliente";
            if (!usuario.fechaCorte)
                errores.fechaCorte = "Debe de elegir una fecha de corte";
        }

        if (aplicaHistorico) {
            if (servicioObjetos.esObjetoVacio(usuario.fechaInicioDescargaHistorico))
                errores.fechaInicioDescargaHistorico = "Debes de agregar un año para la descarga del histórico";
        }
        return errores;
    }

    mostrarContrasena = () => {
        var contrasena = document.getElementById("contrasena");
        var confirmarContrasena = document.getElementById("usuario.confirmacontrasena");
        if (contrasena.type === "password" && confirmarContrasena.type === "password") {
            contrasena.type = "text";
            confirmarContrasena.type = "text";
        } else {
            contrasena.type = "password";
            confirmarContrasena.type = "password";
        }
    }

    editarPlan = () => {
        let { usuario } = this.state;
        const validacion = this.validarCambioPlan(usuario);
        this.setState({ errores: validacion });
        if (servicioObjetos.esObjetoVacio(validacion)) {
            let elPlan = usuario.plan;
            delete usuario.plan;
            delete usuario['plan'];           
            usuario.tcPlan = {
                id: elPlan.id
            };
            let lafecha = usuario.fechaCorte.getTime();
            usuario.fechaCorte = lafecha;
            if (!servicioObjetos.esObjetoVacio(usuario.id))
                usuario.idPlan = elPlan.id;
            let elUrl = 'admin/usuario/cambio_plan.json';
            this.growl.clear();
            servicioHttp.consumirPostHttp(elUrl, usuario).then(response => {
                this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: '', detail: response.data.mensaje, life: 10000 });
                if (!response.data.error) {
                    this.cerrarModalCambioPlan();
                    this.paginar();
                    usuario = {};
                } else {
                    usuario.fechaCorte = new Date(usuario.fechaCorte);
                }
                this.setState({ usuario: usuario });
            }).catch(error => {
                this.growl.show({ severity: 'error', summary: 'Error', detail: "Existe un error de conexión al servidor, intente más tarde", life: 20000 });
            });
        }
    }

    validarCambioPlan = (usuario) => {
        const errores = {};
        if (!usuario.plan)
            errores.plan = "Debe de elegir un plan para el cliente";
        if (!usuario.fechaCorte)
            errores.fechaCorte = "Debe de elegir una fecha de corte";
        return errores;
    }

    mostrarModalDetalleUsuario = (usuario) => {
        this.setState({
            mostrarModalDetalle: true,
            elCliente: usuario
        });
    }

    cerrarModalDetalleUsuario = () => {
        this.setState({
            mostrarModalDetalle: false
        });
    }

    mostrarModalEditarCliente = (usuario) => {
        let usuarioClonado = { ...usuario };
        usuarioClonado.correoconfirmacion = usuario.correo;
        let aplicaHistorico = !servicioObjetos.esObjetoVacio(usuarioClonado.fechaInicioDescargaHistorico);
        if (!servicioObjetos.esObjetoVacio(usuarioClonado.fechaInicioDescargaHistorico))
            usuarioClonado.fechaInicioDescargaHistorico = new Date(usuarioClonado.fechaInicioDescargaHistorico);
        this.setState({
            mostrarEditarCliente: true,
            usuario: usuarioClonado,
            errores: {},
            aplicaHistorico
        });
    }

    cerrarModalEditarCliente = () => {
        this.setState({
            mostrarEditarCliente: false,
            usuario: {},
            errores: {}
        });
    }

    editarCuenta = () => {
        let { usuario } = this.state;
        const errores = this.validarFormulario(usuario);
        this.setState({ errores });
        if (servicioObjetos.esObjetoVacio(errores)) {
            let correoconfirmacion = usuario.correoconfirmacion;
            delete usuario.plan;
            delete usuario['plan'];
            delete usuario.correoconfirmacion;
            delete usuario['correoconfirmacion'];
            delete usuario.confirmacontrasena;
            delete usuario['confirmacontrasena'];
            this.growl.clear();
            if (!servicioObjetos.esObjetoVacio(usuario.fechaInicioDescargaHistorico)) {
                usuario.aplicaHistorico = 1;
                usuario.fechaInicioDescargaHistorico = usuario.fechaInicioDescargaHistorico.getTime();
            }
            servicioHttp.consumirPostHttp("admin/usuario/editar.json", usuario).then(response => {
                this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: '', detail: response.data.mensaje, life: 10000 });
                if (!response.data.error) {
                    this.cerrarModalEditarCliente();
                    this.paginar();
                    usuario = {};
                } else {
                    usuario.correoconfirmacion = correoconfirmacion;
                }
                this.setState({ usuario: usuario });
            }).catch(error => {
                this.growl.show({ severity: 'error', summary: 'Error', detail: "Existe un error de conexión al servidor, intente más tarde", life: 20000 });
            });
        }
    }

    agregarFechaHistorico = (event) => {
        let aplicaHistorico = event.checked;
        let { usuario } = this.state;
        if (aplicaHistorico) {
            let fechaInicioDescargaHistorico = new Date();
            fechaInicioDescargaHistorico.setDate(1);
            fechaInicioDescargaHistorico.setMonth(0);
            fechaInicioDescargaHistorico.setHours(6, 0, 0);
            fechaInicioDescargaHistorico.setMinutes(0);
            fechaInicioDescargaHistorico.setSeconds(0);
            fechaInicioDescargaHistorico.setFullYear(fechaInicioDescargaHistorico.getFullYear() - 5);
            usuario.fechaInicioDescargaHistorico = fechaInicioDescargaHistorico;
        } else {
            usuario.fechaInicioDescargaHistorico = null;
        }
        this.setState({
            aplicaHistorico,
            usuario
        });
    }

    cambioDropDownPlan = (event) => {
        let elementoPlan = event.value;        
        let ahora = new Date();
        ahora.setHours(6, 0, 0);
        ahora.setMinutes(0);
        ahora.setSeconds(0);
        let opcion = elementoPlan.tipo;
        switch (opcion) {
            case 'q':
                ahora.setDate(ahora.getDate() + 15);
                break;
            case 'm':
                ahora.setMonth(ahora.getMonth() + 1);
                break;
            case 'y':
                ahora.setFullYear(ahora.getFullYear() + 1);
                break;

            default:
        }
        let {usuario} =this.state;
        usuario.fechaCorte=ahora;
        usuario.plan=elementoPlan;
        this.setState({usuario});
        this.setState({
            fechaCorteFormateada:servicioFormatos.formatearFechaSinSegundos(ahora)
        });
    }

    render() {
        let { paginacion, errores, usuario, mostrarRegistro, planes,
            mostrarModalPlan, mostrarModalDetalle, elCliente, mostrarEditarCliente, aplicaHistorico,
            fechaCorteFormateada } = this.state;
        let propsNavegador = obtenerInformacionNavegador();


        const pieDialogo = (
            <div className="ui-dialog-buttonpane p-clearfix">
                <Button label="Registrar" icon="pi-md-save" onClick={this.crearCuenta} />
                <Button label="Cancelar" icon="pi-md-close" onClick={this.cerrarModalCrearCliente} className="p-button-danger" />
            </div>
        );

        const pieDialogoEditar = (
            <div className="ui-dialog-buttonpane p-clearfix">
                <Button label="Registrar" icon="pi-md-save" onClick={this.editarCuenta} />
                <Button label="Cancelar" icon="pi-md-close" onClick={this.cerrarModalEditarCliente} className="p-button-danger" />
            </div>
        );

        const pieDialogoCambioPlan = (
            <div className="ui-dialog-buttonpane p-clearfix">
                <Button label="Registrar" icon="pi-md-save" onClick={this.editarPlan} />
                <Button label="Cancelar" icon="pi-md-close" onClick={this.cerrarModalCambioPlan} className="p-button-danger" />
            </div>
        );


        const pieDialogoDetalle = (
            <div className="ui-dialog-buttonpane p-clearfix">
                <Button label="Cancelar" icon="pi-md-close" onClick={this.cerrarModalDetalleUsuario} className="p-button-danger" />
            </div>
        );
        return (<div>
            <Growl ref={(el) => this.growl = el} />
            <div className="card">
                <div className="p-grid">
                    <h1>Administración de clientes</h1>
                </div>
            </div>
            <div className="card">
                <div className="p-grid">
                    <div className="p-col-12 p-md-12">
                        <Button label="Agregar un Cliente" icon="pi-md-person-add" onClick={this.mostrarModalCrearCliente} />
                    </div>
                </div>

                <DataTable value={paginacion.datos} header="Relación de Clientes Registrados"
                paginator={true} rows={100}
                 responsive={true} resizableColumns={true} autoLayout={true}>
                    <Column field="Index" header="Número" body={this.onIndexTemplate} />
                    <Column field="aliasCliente" header="Alias cliente" />
                    <Column field="usuario" header="Usuario" />
                    <Column field="nombre" header="Nombre" />
                    <Column field="apellidoPaterno" header="Apellido Paterno" />
                    <Column field="apellidoMaterno" header="Apellido Materno" />
                    <Column field="correo" header="Correo" />
                    <Column field="numeroMovimientos" header="Movimientos disponibles" />
                    <Column body={this.columnaEstado} header="Estado" />
                    <Column body={this.colunaFechaRegistro} header="Fecha Creación Cuenta" />
                    <Column body={this.colunaFechaCorte} header="Fecha de término de plan" />
                    <Column field="nombrePlan" header="Nombre Plan" />
                    <Column body={this.columnaOpciones} header="Opciones" />
                </DataTable>
            </div>

            <Dialog style={{ width: propsNavegador.device.type === 'desktop' ? '60%' : '90%', height: '90%' }} appendTo={document.body} header={servicioObjetos.esObjetoVacio(usuario.id) ? "Registrar Cliente" : "Editar Cliente"} visible={mostrarRegistro} modal={true} onHide={this.cerrarModalCrearCliente} footer={pieDialogo}>
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <div className="p-grid form-group">
                            <div className="p-col-12 p-md-12"></div>
                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.usuario ? "p-error" : ""} id="usuario.usuario" name="usuario.usuario" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.usuario || ""} maxLength="15" />
                                    <label>*Usuario:</label>
                                </span>
                                {errores.usuario ? <div> <Message severity="error" text={errores.usuario} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.nombre ? "p-error" : ""} id="usuario.nombre" name="usuario.nombre" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, true) }} value={usuario.nombre || ""} maxLength="25" />
                                    <label>*Nombre:</label>
                                    {errores.nombre ? <div> <Message severity="error" text={errores.nombre} /> </div> : null}
                                </span>
                            </div>

                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.apellidoPaterno ? "p-error" : ""} id="usuario.apellidoPaterno" name="usuario.apellidoPaterno" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, true) }} value={usuario.apellidoPaterno || ""} maxLength="25" />
                                    <label>*Apellido Paterno:</label>
                                    {errores.apellidoPaterno ? <div> <Message severity="error" text={errores.apellidoPaterno} /> </div> : null}
                                </span>
                            </div>

                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.apellidoMaterno ? "p-error" : ""} id="usuario.apellidoMaterno" name="usuario.apellidoMaterno" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, true) }} value={usuario.apellidoMaterno || ""} maxLength="25" />
                                    <label>Apellido Materno:</label>
                                    {errores.apellidoMaterno ? <div> <Message severity="error" text={errores.apellidoMaterno} /> </div> : null}
                                </span>
                            </div>


                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <Password ref={el => this.password = el} id="contrasena" name="usuario.contrasena" value={usuario.contrasena || ""} className={errores.contrasena ? "p-error" : ""} onChange={(e) => { this.asignarDatos(e, false) }} style={{ width: '100%' }}
                                        promptLabel="Por favor ingresa una contraseña" weakLabel="Contraseña débil" mediumLabel="Contraseña insegura" strongLabel="Contraseña segura" minLength="8" maxLength="15" />
                                    <label>*Contraseña:</label>
                                    {errores.contrasena ? <div> <Message severity="error" text={errores.contrasena} /> </div> : null}
                                </span>
                            </div>
                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <Password ref={el => this.passwordConfirmacion = el} id="usuario.confirmacontrasena" name="usuario.confirmacontrasena" value={usuario.confirmacontrasena || ""} className={errores.confirmacontrasena ? "p-error" : ""} onChange={(e) => { this.asignarDatos(e, false) }} style={{ width: '100%' }}
                                        promptLabel="Por favor confirma la contraseña" weakLabel="Contraseña débil" mediumLabel="Contraseña insegura" strongLabel="Contraseña segura" minLength="8" maxLength="15" />
                                    <label>*Confirma Contraseña:</label>
                                    {errores.confirmacontrasena ? <div> <Message severity="error" text={errores.confirmacontrasena} /> </div> : null}
                                </span>
                            </div>
                            <div className="p-col-12 p-md-3">
                                <Button onClick={this.mostrarContrasena} icon="pi-md-remove-red-eye" />
                            </div>

                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.correo ? "p-error" : ""} id="usuario.correo" name="usuario.correo" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.correo || ""} maxLength="250" />
                                    <label>*Correo:</label>
                                </span>
                                {errores.correo ? <div> <Message severity="error" text={errores.correo} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.correoconfirmacion ? "p-error" : ""} id="usuario.correoconfirmacion" name="usuario.correoconfirmacion" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.correoconfirmacion || ""} maxLength="250" />
                                    <label>*Confirmar Correo:</label>
                                </span>
                                {errores.correoconfirmacion ? <div> <Message severity="error" text={errores.correoconfirmacion} /> </div> : null}
                            </div>

                            <div className="p-col-12 p-md-2">
                                <label htmlFor="usuario.plan">* Plan:</label>
                            </div>
                            
                            <div className="p-col-12 p-md-12">
                                <Dropdown appendTo={document.body} id="usuario.plan" name="usuario.plan" optionLabel="label" options={planes} value={usuario.plan}
                                    onChange={(e) => this.cambioDropDownPlan(e)} autoWidth={false} style={{ width: "100%" }} className={errores.plan ? "p-error" : ""}
                                    placeholder="Seleccione un plan" />
                                {errores.plan ? <div> <Message severity="error" text={errores.plan} /> </div> : null}
                            </div>

                            <div className="p-col-12 p-md-12">
                                <label>Fecha de término del plan: </label>
                                <label><strong>{fechaCorteFormateada}</strong></label>
                            </div>

                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.aliasCliente ? "p-error" : ""} id="usuario.aliasCliente" name="usuario.aliasCliente" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.aliasCliente || ""} maxLength="250" />
                                    <label>*Alias Cliente:</label>
                                </span>
                                {errores.aliasCliente ? <div> <Message severity="error" text={errores.aliasCliente} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2">
                                <label >* Descarga de Histórico:</label>
                                <Checkbox onChange={e => this.agregarFechaHistorico(e)} checked={aplicaHistorico}></Checkbox>
                            </div>
                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <Calendar id="usuario.fechaInicioDescargaHistorico" name="usuario.fechaInicioDescargaHistorico" disabled={!aplicaHistorico}
                                        value={usuario.fechaInicioDescargaHistorico || ""} className={errores.fechaInicioDescargaHistorico ? "p-error" : ""}
                                        onChange={(e) => { this.asignarDatos(e, false) }} locale={CALENDARIO_ES_MX} view="month" dateFormat="yy" yearNavigator={true} yearRange="2010:2035" />
                                    <label>* Fecha de Incio de descarga de Histórico</label>
                                    {errores.fechaInicioDescargaHistorico ? <div><Message severity="error" text={errores.fechaInicioDescargaHistorico} /></div> : null}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog style={{ width: propsNavegador.device.type === 'desktop' ? '60%' : '90%' }} appendTo={document.body} header={"Cambiar Plan"} visible={mostrarModalPlan} modal={true} onHide={this.cerrarModalCambioPlan} footer={pieDialogoCambioPlan}>
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <div className="p-grid form-group">
                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText disabled className={errores.usuario ? "p-error" : ""} 
                                    id="usuario.usuario" name="usuario.usuario" style={{ width: '100%' }} 
                                    onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.usuario || ""} maxLength="15" />
                                    <label>*Usuario:</label>
                                </span>
                            </div>
                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText disabled className={errores.nombre ? "p-error" : ""} 
                                    id="usuario.nombre" name="usuario.nombre" 
                                    style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, true) }} 
                                    value={usuario.nombre || ""} maxLength="25" />
                                    <label>*Nombre:</label>
                                </span>
                            </div>
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="usuario.plan">* Plan:</label>
                            </div>                           

                            <div className="p-col-12 p-md-12">
                                <Dropdown appendTo={document.body} id="usuario.plan" name="usuario.plan" optionValue="value"
                                optionLabel="label" options={planes} value={usuario.plan}
                                    onChange={(e) => this.cambioDropDownPlan(e)} 
                                    autoWidth={false} style={{ width: "100%" }} className={errores.plan ? "p-error" : ""}
                                    placeholder="Seleccione un plan" />
                                {errores.plan ? <div> <Message severity="error" text={errores.plan} /> </div> : null}
                            </div>

                            <div className="p-col-12 p-md-12">
                                <label>Fecha de término del plan: </label>
                                <label><strong>{fechaCorteFormateada}</strong></label>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog style={{ width: propsNavegador.device.type === 'desktop' ? '90%' : '90%' }} appendTo={document.body} header={"Detalle movimientos"} visible={mostrarModalDetalle} modal={true} onHide={this.cerrarModalDetalleUsuario} footer={pieDialogoDetalle}>
                <DetalleMovimientosCliente elCliente={elCliente} />
            </Dialog>

            <Dialog id="modalEditarCliente" style={{ width: propsNavegador.device.type === 'desktop' ? '60%' : '90%', height: '90%' }} appendTo={document.body} header={"Editar Cliente"} visible={mostrarEditarCliente} modal={true} onHide={this.cerrarModalEditarCliente} footer={pieDialogoEditar}>
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <div className="p-grid form-group">
                            <div className="p-col-12 p-md-12"></div>
                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.usuario ? "p-error" : ""} id="usuario.usuario" name="usuario.usuario" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.usuario || ""} maxLength="15" />
                                    <label>*Usuario:</label>
                                </span>
                                {errores.usuario ? <div> <Message severity="error" text={errores.usuario} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.nombre ? "p-error" : ""} id="usuario.nombre" name="usuario.nombre" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, true) }} value={usuario.nombre || ""} maxLength="25" />
                                    <label>*Nombre:</label>
                                    {errores.nombre ? <div> <Message severity="error" text={errores.nombre} /> </div> : null}
                                </span>
                            </div>

                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.apellidoPaterno ? "p-error" : ""} id="usuario.apellidoPaterno" name="usuario.apellidoPaterno" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, true) }} value={usuario.apellidoPaterno || ""} maxLength="25" />
                                    <label>*Apellido Paterno:</label>
                                    {errores.apellidoPaterno ? <div> <Message severity="error" text={errores.apellidoPaterno} /> </div> : null}
                                </span>
                            </div>

                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.apellidoMaterno ? "p-error" : ""} id="usuario.apellidoMaterno" name="usuario.apellidoMaterno" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, true) }} value={usuario.apellidoMaterno || ""} maxLength="25" />
                                    <label>Apellido Materno:</label>
                                    {errores.apellidoMaterno ? <div> <Message severity="error" text={errores.apellidoMaterno} /> </div> : null}
                                </span>
                            </div>

                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.correo ? "p-error" : ""} id="usuario.correo" name="usuario.correo" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.correo || ""} maxLength="250" />
                                    <label>*Correo:</label>
                                </span>
                                {errores.correo ? <div> <Message severity="error" text={errores.correo} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.correoconfirmacion ? "p-error" : ""} id="usuario.correoconfirmacion" name="usuario.correoconfirmacion" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.correoconfirmacion || ""} maxLength="250" />
                                    <label>*Confirmar Correo:</label>
                                </span>
                                {errores.correoconfirmacion ? <div> <Message severity="error" text={errores.correoconfirmacion} /> </div> : null}
                            </div>

                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <InputText className={errores.aliasCliente ? "p-error" : ""} id="usuario.aliasCliente" name="usuario.aliasCliente" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.aliasCliente || ""} maxLength="250" />
                                    <label>*Alias Cliente:</label>
                                </span>
                                {errores.aliasCliente ? <div> <Message severity="error" text={errores.aliasCliente} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2">
                                <label >* Descarga de Histórico:</label>
                                <Checkbox onChange={e => this.agregarFechaHistorico(e)} checked={aplicaHistorico}></Checkbox>
                            </div>
                            <div className="p-col-12 p-md-12">
                                <span className="md-inputfield">
                                    <Calendar id="usuario.fechaInicioDescargaHistorico" name="usuario.fechaInicioDescargaHistorico" disabled={!aplicaHistorico}
                                        value={usuario.fechaInicioDescargaHistorico || ""} className={errores.fechaInicioDescargaHistorico ? "p-error" : ""}
                                        onChange={(e) => { this.asignarDatos(e, false) }} locale={CALENDARIO_ES_MX} view="month" dateFormat="yy" yearNavigator={true} yearRange="2010:2035" />
                                    <label>* Fecha de Incio de descarga de Histórico</label>
                                    {errores.fechaInicioDescargaHistorico ? <div><Message severity="error" text={errores.fechaInicioDescargaHistorico} /></div> : null}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>);
    }
}